import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { SELECTED_HEADER_MENU, SITE_ID, SELECTED_APP_SITE, SITE_VALUE, STAFF_LOGIN_DETAIL, } from "../../redux/actions/types";
import APP_ROUTES from "../../helper/app-routes";
import { permissionEnum, userIsAdmin, userIsSuperAdmin } from "../..//helper/permission-helper";
import moment from "moment";
import { API_ENDPOINTS } from "src/services/api-endpoints";
import { customAxios } from "src/services/useExPressApi";
import MultiSelectDropDown from "../multi-select-drop-down/multi-select-drop-down";
import { getGlobalClinicSites, openDashBoardCard } from "src/redux/actions";
import { Tooltip } from "@progress/kendo-react-tooltip";

function MenuHeader() {
  const defaultSite = useSelector((state) => state.getStaffReducer);
  const [showMenuBar, setShowMenuBar] = useState(true);

  const [siteData, setSiteData] = useState([]);

  const [isShown, setIsShown] = useState(false);
  const [isBillingShow, setBillingShow] = useState(false);
  const [loginData, setLoginData] = React.useState("");
  const getRolePermission = useSelector(
    (state) => state.getRolePermission.canModifyClinicRoles
  );
  const isBillingManager = useSelector(
    (state) => state.getRolePermission.isBillingManager
  );
  const staffLoginInfo = useSelector((state) => state.getStaffReducer);
  const isImpersonating = useSelector(state => state.LoggedInReducer.appIsImpersonate);
  const [currentTab, setCurrentTab] = useState({ id: '1', name: 'Dashboard', route: '/dashboard', className: 'nav-link' })
  const siteIds = useSelector((state) => state.getSiteId);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const newPath = location.pathname.toLowerCase();
  let d = newPath.split("/");
  let primaryPath = d[1];
  const refSite = useRef(null);
  const dropDownRef = useRef(null);
  const refSiteClose = useRef(null);
  const [openSiteFilter, setOpenSiteFilter] = useState(false);
  const [selectedSites, setSelectedSites] = useState([])
  const [selectedSitesLocal, setSelectedSitesLocal] = useState([])
  const state = useSelector(states => {
    return states;
  });
  const { clinicGLobalSites } = state["ClinicsReducer"]
  const userAccessPermission = useSelector(
    (state) => state.userAccessPermission
  );

  useEffect(() => {
    dispatch(getGlobalClinicSites())
  }, []);

  useEffect(() => {
    if (isImpersonating) {
      getLoginDetail();
    }
  }, []);


  const handleClickListener = async (event) => {
    if (
      refSite.current &&
      !refSite.current.contains(event.target)

    ) {
      if (event.defaultPrevented) {
        return;
      }
      setTimeout(() => {
        setOpenSiteFilter(false)
      }, 100)
    }
  };

  useEffect(() => {

    document.addEventListener('mousedown', handleClickListener);


    return () => {
      document.removeEventListener('mousedown', handleClickListener);
    };
  }, []);

  const handleChange = (siteList) => {
    let result = siteList?.map((foo) => foo.siteId)
    dispatch({
      type: SITE_ID,
      payload: result,
    });
    dispatch({
      type: SELECTED_APP_SITE,
      payload: result,
    });
  };

  useEffect(() => {
    let newArr = []
    if (siteIds && siteIds.length > 0) {

      clinicGLobalSites.map((currentSite) => {
        const isStateData = siteIds.find((id) => id === currentSite.siteId)
        if (isStateData) {
          newArr.push(currentSite)
        }
      })
    }
    setSelectedSites(newArr)
    setSelectedSitesLocal(newArr)
    dispatch({ type: SITE_VALUE, payload: clinicGLobalSites });
    setSiteData(clinicGLobalSites);
  }, [clinicGLobalSites])




  const getLoginDetail = async () => {
    const sessionResp = await customAxios.get(`${API_ENDPOINTS.GET_LOGIN_STAFF}`);
    if (sessionResp && sessionResp.resultData) {
      let loginData = sessionResp.resultData;
      setLoginData(loginData);
      dispatch({
        type: STAFF_LOGIN_DETAIL,
        payload: loginData,
      });
    }
  };


  const menus = [
    {
      id: "1",
      name: "Dashboard",
      route: APP_ROUTES.DASHBOARD,
      className: primaryPath === "dashboard" ? "nav-link active" : "nav-link",
    },
    {
      id: "2",
      name: "Staff",
      route: APP_ROUTES.GET_STAFF,
      className: primaryPath === "staff" ? "nav-link active" : "nav-link",
    },
    {
      id: "3",
      name: "Clients",
      route: APP_ROUTES.GET_CLIENT,
      className: primaryPath === "client" ? "nav-link active" : "nav-link",
    },
    {
      id: "4",
      name: "Messages",
      route: APP_ROUTES.MESSAGE,
      className: primaryPath === "messages" ? "nav-link active" : "nav-link",
    },
    {
      id: "5",
      name: "Calendar",
      route: APP_ROUTES.SCHEDULER,
      className: primaryPath === "scheduler" ? "nav-link active" : "nav-link",
    },
    {
      id: "6",
      name: "Documents",
      route: APP_ROUTES.DOCUMENT_LIST,
      className: primaryPath === "document" ? "nav-link active" : "nav-link",
    },
  ];

  const clinicMenuItems = [];
  if (userIsAdmin(staffLoginInfo?.roleId) || userIsSuperAdmin(staffLoginInfo?.roleId)) {
    clinicMenuItems.push(
      {
        id: "1",
        name: "Document Templates",
        route: APP_ROUTES.DOCUMENT_TEMPLATE_LIST,
        className:
          newPath === APP_ROUTES.DOCUMENT_TEMPLATE_LIST
            ? "dropdown-item active"
            : "dropdown-item",
        value: true,
        isPermission: userIsAdmin(staffLoginInfo?.roleId),
      })
  }
  if (userIsAdmin(staffLoginInfo?.roleId) || userIsSuperAdmin(staffLoginInfo?.roleId)) {
    clinicMenuItems.push(
      {
        id: "2",
        name: "Services",
        route: APP_ROUTES.GET_SERVICE_BY_CLINICID,
        className:
          primaryPath === "services" ? "dropdown-item active" : "dropdown-item",
        value: true,
        isPermission: userIsAdmin(staffLoginInfo?.roleId),
      })
  }
  if (userIsAdmin(staffLoginInfo?.roleId) || userIsSuperAdmin(staffLoginInfo?.roleId)) {
    clinicMenuItems.push(
      {
        id: "3",
        name: "Sites",
        route: APP_ROUTES.GET_CLINIC_SITE,
        className:
          primaryPath === "provider" ? "dropdown-item active" : "dropdown-item",
        value: true,
        isPermission: userIsAdmin(staffLoginInfo?.roleId),
      })
  }
  if (userIsAdmin(staffLoginInfo?.roleId) || userIsSuperAdmin(staffLoginInfo?.roleId)) {
    clinicMenuItems.push(
      {
        id: "4",
        name: "Settings",
        route: APP_ROUTES.CLINIC_INFO,
        className:
          primaryPath === "settings" ? "dropdown-item active" : "dropdown-item",
        value: true,
        isPermission: userIsAdmin(staffLoginInfo?.roleId),
      })
  }
  if (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_CLIENT_COMPLIANCE]) {
    clinicMenuItems.push(
      {
        id: "5",
        name: "Client Compliance",
        route: APP_ROUTES.CLIENT_COMPLIANCE,
        className:
          primaryPath === "client-compliance" ? "dropdown-item active" : "dropdown-item",
        value: true,
        isPermission: (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_CLIENT_COMPLIANCE]),
      })
  }
  // {
  //   id: "8",
  //   name: "Compliance Report",
  //   route: APP_ROUTES.COMPLIANCE_REPORT,
  //   className:
  //     primaryPath == "compliance-report" ? "dropdown-item active" : "dropdown-item",
  //   value: true,
  //   isPermission: userIsAdmin(staffLoginInfo?.roleId),
  // },

  // {
  //   id: "11",
  //   name: "Authorization Set",
  //   route: APP_ROUTES.AUTHORIZATION_SETS,
  //   className:
  //     primaryPath == "authorization-sets" ? "dropdown-item active" : "dropdown-item",
  //   value: true,
  //   isPermission: userIsAdmin(staffLoginInfo?.roleId),
  // },
  // {
  //   id: "6",
  //   name: "Roles",
  //   route: APP_ROUTES.ROLES,
  //   className:
  //     primaryPath == "roles" ? "dropdown-item active" : "dropdown-item",
  //   // value: settingSwitch.canModifyClinicRoles,
  //   value: getRolePermission,
  //   isPermission: true,
  // },
  if (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_AUTHORIZATIONS]) {
    clinicMenuItems.push(
      {
        id: "7",
        name: "Authorizations",
        route: APP_ROUTES.MULTIPLE_CLIENT_SERVICE_AUTH,
        className:
          primaryPath === "authorizations"
            ? "dropdown-item active"
            : "dropdown-item",
        // value: settingSwitch.canModifyClinicRoles,
        value: true,
        isPermission: userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_AUTHORIZATIONS],

      })
  }
  if (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_DEFAULT_GOALS]) {
    clinicMenuItems.push(
      {
        id: "10",
        name: "Default Goals",
        route: APP_ROUTES.DEFAULT_GOLAS,
        className:
          primaryPath === "defaultgoals"
            ? "dropdown-item active"
            : "dropdown-item",
        value: true,
        isPermission: (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_DEFAULT_GOALS]),
      })
  }
  // {
  //   id: "9",
  //   name: "Service Sets",
  //   route: APP_ROUTES.SERVICE_SETS,
  //   className:
  //     primaryPath == "servicesets"
  //       ? "dropdown-item active"
  //       : "dropdown-item",
  //   value: true,
  //   isPermission: userIsAdmin(staffLoginInfo?.roleId),
  // },
  if (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.SHOW_CLINIC_FILES]) {
    clinicMenuItems.push(
      {
        id: "9",
        name: "Clinic Files",
        route: APP_ROUTES.CLINIC_FILE,
        className:
          primaryPath === "clinic-file"
            ? "dropdown-item active"
            : "dropdown-item",
        value: true,
        isPermission: (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.SHOW_CLINIC_FILES]),
      })
  }

  if (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_CLIENT_FILES]) {
    clinicMenuItems.push(
      {
        id: "10",
        name: "Client Files",
        route: APP_ROUTES.CLIENT_FILE,
        className:
          primaryPath === "client-file"
            ? "dropdown-item active"
            : "dropdown-item",
        value: true,
        isPermission: (userIsSuperAdmin(staffLoginInfo?.roleId) || userAccessPermission[permissionEnum.MANAGE_CLIENT_FILES]),
      })
  }

  // ];
  if (getRolePermission) {
    clinicMenuItems.push(
      {
        id: "6",
        name: "Roles",
        route: APP_ROUTES.ROLES,
        className:
          primaryPath === "roles" ? "dropdown-item active" : "dropdown-item",
        // value: settingSwitch.canModifyClinicRoles,
        value: getRolePermission,
        isPermission: true,
      })
  }

  clinicMenuItems.push(
    {
      id: "7",
      name: "Staff Documents",
      route: APP_ROUTES.STAFF_DOCUMENTS,
      className:
        primaryPath === "staff-documents" ? "dropdown-item active" : "dropdown-item",
      value: true,
      isPermission: true,
    })

  clinicMenuItems.push(
    {
      id: "10",
      name: "Parental Access (CP)",
      route: APP_ROUTES.CLIENT_PORTAL_ACCESS,
      className:
        primaryPath === "client-portal-account-access" ? "dropdown-item active" : "dropdown-item",
      value: true,
      isPermission: true,
    })

  const accessMenuItems = [
    {
      id: "1",
      name: "Task Manager",
      route: APP_ROUTES.TASK_MANAGER,
      className:
        primaryPath === "task" ? "dropdown-item active" : "dropdown-item",
    },
    (userIsSuperAdmin(staffLoginInfo?.roleId) || userIsAdmin(staffLoginInfo?.roleId)) && {
      id: "2",
      name: "Administrative Board",
      route: APP_ROUTES.DASHBOARD_CHART,
      className:
        primaryPath === "dashboardchart" ? "dropdown-item active" : "dropdown-item",
      isPermission: userIsSuperAdmin(staffLoginInfo?.roleId)
    },
    {
      id: "3",
      name: "Time Clock",
      route: APP_ROUTES.TIMECLOCK,
      className:
        primaryPath === "time-clock"
          ? "dropdown-item active"
          : "dropdown-item",
      value: true,
      isPermission: true,
    },
    {
      id: "4",
      name: "Knowledge Base",
      route: "https://notenetic.zendesk.com/hc/en-us/categories/27628981756699-Articles",
      isExternal: true,
      className:
        primaryPath === "knowledge-base"
          ? "dropdown-item active"
          : "dropdown-item",
      value: true,
      isPermission: true,
    },
    {
      id: "5",
      name: "Reports",
      route: APP_ROUTES.REPORT_MANAGER,
      className:
        primaryPath === "report-manager" ? "dropdown-item active" : "dropdown-item",
    },
  ];
  if (userIsSuperAdmin(staffLoginInfo?.roleId)) {
    accessMenuItems.push({
      id: "6",
      name: "Subscriptions",
      route: APP_ROUTES.SUBSCRIPTION_MANAGER,
      className:
        primaryPath === "subscription-manager" ? "dropdown-item active" : "dropdown-item",
    })
  }




  // const dashbaordGrapgh = [
  //   {
  //     id: "1",
  //     name: "Dashboard Graph",
  //     route: APP_ROUTES.DASHBOARD_CHART,
  //     className:
  //       primaryPath == "" ? "dropdown-item active" : "dropdown-item",
  //   },
  // ];

  const AuditMenuItems = [
    {
      id: "1",
      name: "Staff Audit",
      route: APP_ROUTES.STAFF_AUDIT,
      className: primaryPath === "staffaudit" ? "dropdown-item active" : "dropdown-item",
    },
    {
      id: "2",
      name: "Client Audit",
      route: APP_ROUTES.CLIENT_AUDIT,
      className: primaryPath === "clientaudit" ? "dropdown-item active" : "dropdown-item",
    },
    {
      id: "3",
      name: "Telehealth Logs",
      route: APP_ROUTES.TELEHEALTH_LOGS,
      className: primaryPath === "telehealthlogs" ? "dropdown-item active" : "dropdown-item",
    },
    // {
    //   id: "3",
    //   name: "Clinic Audit",
    //   route: APP_ROUTES.CLINIC_AUDIT,
    //   className:
    //     primaryPath == "Clinic" ? "dropdown-item active" : "dropdown-item",
    // },
  ];

  const billingItems = [
    {
      id: "1",
      name: "New Billing",
      route: APP_ROUTES.NEW_BILLING,
      className:
        newPath === APP_ROUTES.NEW_BILLING
          ? "dropdown-item active"
          : "dropdown-item",
      value: true,
    },
    {
      id: "2",
      name: "Billing Submissions",
      route: APP_ROUTES.BILLING_TRANSACTION,
      className:
        newPath === APP_ROUTES.BILLING_TRANSACTION
          ? "dropdown-item active"
          : "dropdown-item",
      value: true,
    },
    {
      id: "3",
      name: "Billing Remittance",
      route: APP_ROUTES.BILLING_REMITTANCE,
      className:
        newPath === APP_ROUTES.BILLING_REMITTANCE
          ? "dropdown-item active"
          : "dropdown-item",
      value: true,
    },
    {
      id: "4",
      name: "Billing Profiles",
      route: APP_ROUTES.BILLING_PROFILE,
      className:
        newPath === APP_ROUTES.BILLING_PROFILE ? "dropdown-item active" : "dropdown-item",
      value: true,
    },

    {
      id: "5",
      name: "Aging Report",
      route: APP_ROUTES.BILLING_AGING_REPORT,
      className:
        newPath === APP_ROUTES.BILLING_AGING_REPORT ? "dropdown-item active" : "dropdown-item",
      value: true,
    },
  ];


  const onMenuSelect = (e, obj) => {
    e.preventDefault();
    navigate(obj.route);
    setShowMenuBar(!showMenuBar);
    dispatch({
      type: SELECTED_HEADER_MENU,
      payload: obj,
    });
  };

  const onMoreMenuSelect = (e, obj) => {
    e.preventDefault();
    setIsShown(false);
    setShowMenuBar(!showMenuBar);
    setBillingShow(false);
    navigate(obj.route);
  };
  const currentNavigation = useSelector((state) => state.selectedHeaderMenu);


  useEffect(() => {
    if (currentNavigation) {
      setCurrentTab(currentNavigation)
    }
  }, [currentNavigation])



  function renderToItem(li, itemProps) {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  }



  return (
    <>
      <div className="menu-header-items">
        <header className="inner-header position-relative ">
          <div className="container-fluid d-flex justify-content-between align-items-baseline bgWHite nav-shadow">
            <nav className="navbar navbar-expand-lg navbar-light p-0">
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                {/* {/ { <span className="navbar-toggler-icon"></span > } /} */}
              </button>
              <div
                className={`collapse navbar-collapse custome-nav cursor-pointer${showMenuBar ? "show" : " "
                  }`}
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mb-2 mb-lg-0">
                  {menus.map((obj, index) => (
                    <li key={index} className="nav-item">
                      <a
                        href={obj.route}
                        className={obj.className}
                        onClick={(e) => {
                          onMenuSelect(e, obj);
                        }}
                      >
                        {obj.name}
                      </a>
                    </li>
                  ))}

                  {
                    (isBillingManager || userIsSuperAdmin(staffLoginInfo?.roleId)) &&

                    <li className="nav-item dropdown more-btn-drop  d-lg-block ">
                      <a
                        onMouseOver={() => setBillingShow(true)}
                        onMouseLeave={() => setBillingShow(true)}
                        className="nav-link dropdown-toggle"
                        type="button"
                      >
                        Billing <i className="fa fa-angle-down" aria-hidden="true"></i>
                      </a>
                      {isBillingShow && (
                        <div className="dropdown-menu-t">
                          <div className="drop-downlist-billing">
                            <div className="d-flex flex-wrap">
                              <div className="col-md-12 list-unstyled col-12 mb-0 p-0">
                                <div className="mb-2">

                                  <ul className="list-unstyled pt-0 pb-0 innerUlList">
                                    {billingItems
                                      .filter((item) => {
                                        return item.value !== false;
                                      })
                                      .map((obj, index) => (
                                        <li key={index} className="mb-1">
                                          <a
                                            className={obj.className}
                                            href={obj.route}
                                            onClick={(e) => {
                                              onMoreMenuSelect(e, obj);
                                            }}
                                          >
                                            {obj.name}
                                          </a>
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="border-bottom-line"></div>
                          </div>
                        </div>
                      )}
                    </li>
                  }

                  <li className="nav-item dropdown more-btn-drop  d-lg-block ">
                    <a
                      onMouseOver={() => setIsShown(true)}
                      className="nav-link dropdown-toggle"
                      type="button"
                    >
                      More <i className="fa fa-angle-down" aria-hidden="true"></i>
                    </a>
                    {isShown && (
                      <div className="dropdown-menu-t">
                        <div className="drop-downlist">
                          <div className="d-flex flex-wrap">
                            <div className="col-md-6 list-unstyled col-12 mb-0 p-0 drop-down" >
                              <div className="mb-2">
                                <a className="dropdown-item heading">
                                  <h6 className="mb-1">Clinic</h6>
                                </a>
                                <ul className="list-unstyled pt-0 pb-0 innerUlList">
                                  {clinicMenuItems.sort((a, b) => {
                                    if (a.name < b.name) {
                                      return -1;
                                    }
                                    if (a.name > b.name) {
                                      return 1;
                                    }
                                    return 0;
                                  })
                                    .filter((item) => {
                                      return item.value !== false;
                                    })
                                    .map((obj, index) => (
                                      <li key={index} className="mb-1">
                                        <a
                                          className={obj.className}
                                          href={obj.route}
                                          onClick={(e) => {
                                            onMoreMenuSelect(e, obj);
                                          }}
                                        >
                                          {obj.isPermission === true
                                            ? obj.name
                                            : ""}
                                        </a>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            </div>
                            <div className="col-md-6 list-unstyled col-12 mb-0">
                              {userIsAdmin(staffLoginInfo?.roleId) && (
                                <div className="mb-2">
                                  <a className="dropdown-item heading">
                                    <h6 className="mb-1">Audit</h6>
                                  </a>
                                  <ul className="list-unstyled pt-0 pb-0 innerUlList innerUlList">
                                    {AuditMenuItems.map((obj, index) => (
                                      <li key={index} className="mb-1">
                                        <a
                                          className={obj.className}
                                          href={obj.route}
                                          onClick={(e) => {
                                            onMoreMenuSelect(e, obj);
                                          }}
                                        >
                                          {obj.name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              <div className="mb-2">
                                <a className="dropdown-item heading">
                                  <h6 className="mb-1">Misc.</h6>
                                </a>
                                <ul className="list-unstyled pt-0 pb-0 innerUlList">
                                  {accessMenuItems.map((obj, index) => {
                                    if (obj.isExternal) {
                                      return (
                                        <li key={index} className="mb-1">
                                          <a
                                            href={obj.route}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={obj.className}
                                          >
                                            {obj.name}
                                          </a>
                                        </li>
                                      );
                                    } else {
                                      return (
                                        <li key={index} className="mb-1">
                                          <a
                                            className={obj.className}
                                            href={obj.route}
                                            onClick={(e) => {
                                              onMoreMenuSelect(e, obj);
                                            }}
                                          >
                                            {obj.name}
                                          </a>
                                        </li>
                                      );
                                    }
                                  })}
                                </ul>
                              </div>


                            </div>
                          </div>
                          <div className="border-bottom-line"></div>
                        </div>
                      </div>
                    )}
                  </li>
                </ul>
              </div>

            </nav>
            {(currentTab && currentTab.id.toString() === '1' && currentTab.name === 'Dashboard' && location.pathname === "/dashboard") &&
              <div className='d-flex align-items-center dashboard-right'>
                <div className="mr-2 dashboard-header">Filter Dashboard by Site</div>

                <div
                  ref={refSite}
                  onClick={(event) => {
                    if (!refSiteClose.current?.contains(event.target)) {
                      setOpenSiteFilter(true)
                    }
                  }
                  }
                  className="service-main dropdown email-filter border-dashed-cus2 position-relative staffButton"
                >
                  <button className="btn  btn-size-cus pl-0 pt-0" type="button">
                    {selectedSites?.length > 0 ? (
                      <i
                        ref={refSiteClose}
                        onClick={(event) => {
                          event.stopPropagation();
                          setSelectedSitesLocal([])
                          setSelectedSites([])
                          handleChange([])
                          setTimeout(() => {
                            setOpenSiteFilter(false)
                          }, 100)
                        }}
                        className={"fa fa-times cross-icon mr-2 "}
                      ></i>
                    ) : (
                      <i
                        className={"fa fa-plus cross-icon "}
                      ></i>
                    )}     {(!selectedSites || !selectedSites.length > 0) ? 'Site' : ''}
                    {selectedSites?.length > 0 && (
                      <span>
                        {selectedSites[0]?.siteName} {(selectedSites?.length > 1) ? '(+' + (selectedSites?.length - 1) + ')' : ''}
                      </span>
                    )}
                  </button>

                  {openSiteFilter && (
                    <div className="dropdown-service dropInputField service-dropdown filter-left-align">
                      <div className="row justify-content-end">
                        <div ref={refSiteClose} className="col-lg-4 col-md-8 col-sm-12">
                          <div className="text-end ">
                            <button onClick={(event) => {
                              event.preventDefault();
                              setSelectedSites(selectedSitesLocal)
                              setTimeout(() => {
                                setOpenSiteFilter(false)
                              }, 100)
                              handleChange(selectedSitesLocal)
                            }} type="button" className="submitButon" >
                              Apply
                            </button>
                          </div>
                        </div>
                        <div className="col-md-12 ">
                          <MultiSelectDropDown
                            data={siteData}
                            value={selectedSitesLocal}
                            textField="siteName"
                            dataItemKey="siteId"
                            name={'sites'}
                            label={'Site(s)'}
                            filterable={true}
                            onChange={(event) => {
                              setSelectedSitesLocal(event.target.value)
                            }}
                            itemRender={renderToItem}
                            autoClose={false}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>




                {/* <div className="header-site-cus" style={{
                    width: "320px",
                    height: "30px",
                    padding: "0",
                    marginTop: "0px",
                  }}>
                </div> */}

                <div className="d-flex justify-content-end dashboard-header-setting" style={{ cursor: 'pointer', fontSize: '18px' }}  onClick={()=>dispatch(openDashBoardCard(1))}>
                  <Tooltip anchorElement="target" position="top">
                    <i className="cursor-pointer fa fa-cog" title="Manage Dashboard Cards" />
                  </Tooltip>
                </div>

              </div>

            }
          </div>
        </header>

      </div>
      {isImpersonating &&
        <div className="headerBottomText">
          <div className="container-fluid">
            <p className="m-0" > {moment(new Date()).format("M/D/yyyy hh:mm A")}: You are currently impersonating as {loginData.firstName} {loginData.lastName}({loginData.roleName})</p>
          </div>
        </div>
      }

    </>

  );
}
export default MenuHeader;
